import { ProfileToneDto } from '../../../dto/profiletune/profiletonedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface SetStatusToneRequest extends APIRequest
{
    getSetStatusToneRequest(): ProfileToneDto;
}

export class SetStatusToneRequestImpl extends APIRequestDtoImpl implements SetStatusToneRequest
{
    constructor(private data: ProfileToneDto)
    {
        super();
    }

    getSetStatusToneRequest(): ProfileToneDto
    {
        return this.data;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/statustune/setstatustune/setstatustonepricerequest.tsx